<script>
    import Transition from "../components/Transition.svelte";
</script>

<Transition>Hello (slim server)</Transition>
